import React from 'react';
import { Modal, Input, Select, notification, Form, Space, Button } from 'antd';
import { post } from '../../utils/http';
import api from '../../utils/api';
import { sessionManager } from '../../core/SessionManager';

const { Option } = Select;
const { confirm } = Modal;

export default function EditDetailInformation(props) {
    const merchantId = props.editValue.merchantId
    const [merchantName, setMerchantName] = React.useState(props.editValue.merchantName);
    const [mobileNumber, setMobileNumber] = React.useState(props.editValue.mobileNumber);
    const [password, setPassword] = React.useState(props.editValue.password);
    const [confirmLoading, setConfirmLoading] = React.useState(false);
    const username = sessionManager.getUserInfo().userName;
    const handleSubmit = () => { //submit button
        setConfirmLoading(true)
        const editData = {
            merchantId: merchantId,
            merchantName: merchantName,
            mobileNumber: mobileNumber,
            password: password,
            username: username,
            displayTrue: { style: { display: "inline-block" } },
            displayFalse: { style: { display: "none" } },
            modalFooter: {} 
        }

        post(api.saveAndUdtMerchant, editData).then(function (response) {
            notification['success']({
                message: 'Update successfully.',
            });
            props.closeEditModal()
            props.handleSearch()
            setConfirmLoading(false)

        }).catch(function (error) {

            notification['error']({
                message: 'Fail to update.',
            });
            console.log(error)
            setConfirmLoading(false)
        })
    }
    const layers = [];
    for (let i = 1; i < 7; i++) {
        layers.push(<Option key={i}>{"L" + i}</Option>)
    }

    const handleCancle = () => {
        confirm({
            content: "Are you sure to close this modal?",
            onOk() {
                Modal.destroyAll();
                props.closeEditModal();
            }
        });
    };

    const checkMobileNumber = (value) => {
        if (value !== "" && !(/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/.test(value))) {
            notification['warning']({
                message: 'Please input correct Mobile Number!',
            });
        }
    }

    return (
        <>
            <Modal
                title="Edit merchant"
                visible={props.isOpenEdit}
                confirmLoading={confirmLoading}
                onCancel={handleCancle}
                destroyOnClose={true}
                footer={null}
            >
                <Form
                    name="edit_merchant"
                    onFinish={handleSubmit}
                    labelCol={{ span: 7 }}
                    autoComplete="off"
                    >
                    <Form.Item
                        name="Merchant Name"
                        label="Merchant Name"
                        rules={[{ required: true, message: 'Please input Merchant Name!' }]}
                        initialValue={merchantName}
                    >
                        <Input placeholder="merchantName" onChange={event => setMerchantName(event.target.value)} style={{ height: "36px", width: "300px" }} />
                    </Form.Item>
                    <Form.Item
                        name="Mobile Number"
                        label="Mobile Number"
                        rules={[{ required: true, message: 'Please input Mobile Number!' }]}
                        initialValue={mobileNumber}
                    >
                        <Input defaultValue={mobileNumber} placeholder="mobileNumber" onBlur={event => checkMobileNumber(event.target.value)} onChange={event => setMobileNumber(event.target.value)} style={{ height: "36px", width: "300px" }} />
                    </Form.Item>
                    <Form.Item
                        name="Password"
                        label="Password"
                        rules={[{ required: true, message: 'Please input Password!' }]}
                        initialValue={password}
                    >
                        <Input defaultValue={password} placeholder="password" onChange={event => setPassword(event.target.value)} style={{ height: "36px", width: "300px" }} />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 16, span: 16 }}>
                        <Space>
                            <Button size="large" htmlType="button" onClick={handleCancle}>
                                Cancel
                            </Button>
                            <Button size="large" type="primary" htmlType="submit" >
                                OK
                            </Button>
                        </Space>
                    </Form.Item> 
                </Form>
            </Modal>
        </>
    )
}